import React, { useEffect } from 'react';
import { CheckCircle, Download, MessageCircle, Clock, CalendarCheck } from 'lucide-react';
import { trackEvent } from '../lib/fbpixel';
const GUIDE_URL = 'https://assets.cdn.filesafe.space/GMEcWNzGhwtEITM4JsWs/media/6a021497b7ca635d75d42d6a.pdf';
export function ThankYouPage() {
  useEffect(() => {
    trackEvent('CompleteRegistration');
  }, []);
  return <div className="h-screen bg-bunker font-sans text-earth flex flex-col overflow-hidden" data-id="element-226">
      {/* Top brand bar */}
      <div className="bg-pitahaya text-white text-center py-2 px-4 text-[10px] sm:text-xs font-bold uppercase tracking-widest shrink-0" data-id="element-227">
        ✅ Registro confirmado — Tu asesor ha sido notificado
      </div>

      {/* MAIN */}
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 py-3 sm:py-6 relative overflow-hidden" data-id="element-228">
        {/* Background */}
        <div className="absolute inset-0 z-0" data-id="element-229">
          <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=2832&auto=format&fit=crop" alt="Yucatan Land" className="w-full h-full object-cover object-center" data-id="element-230" />
          <div className="absolute inset-0 bg-bunker/90" data-id="element-231"></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto w-full" data-id="element-232">
          {/* Success badge */}
          <div className="flex justify-center mb-3 sm:mb-5" data-id="element-233">
            <div className="relative" data-id="element-234">
              <div className="absolute inset-0 bg-pitahaya rounded-full blur-2xl opacity-40 animate-pulse" data-id="element-235"></div>
              <div className="relative inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-pitahaya rounded-full shadow-2xl shadow-pitahaya/40" data-id="element-236">
                <CheckCircle className="w-7 h-7 sm:w-8 sm:h-8 text-white" strokeWidth={2.5} data-id="element-237" />
              </div>
            </div>
          </div>

          <div className="text-center mb-4 sm:mb-6" data-id="element-238">
            <div className="inline-flex border border-pitahaya/50 bg-pitahaya/10 px-3 py-1 rounded-full mb-3" data-id="element-239">
              <span className="text-pitahaya font-bold text-[10px] sm:text-[11px] tracking-widest uppercase" data-id="element-240">
                Gracias, has completado tu registro
              </span>
            </div>

            <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-[1.15] mb-3 tracking-tight" data-id="element-241">
              Espera nuestro{' '}
              <span className="text-pitahaya italic" data-id="element-242">WhatsApp</span> en las
              próximas 24 horas
            </h1>

            <p className="font-sans text-sm sm:text-base text-earth/80 max-w-2xl mx-auto leading-relaxed" data-id="element-243">
              Uno de nuestros asesores patrimoniales te contactará para{' '}
              <strong className="text-white" data-id="element-244">
                agendar tu entrevista privada sin costo
              </strong>
              .
            </p>
          </div>

          {/* MAIN CARD — Call expectation */}
          <div className="bg-earth text-bunker rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-2xl shadow-bunker/50 mb-3 sm:mb-4" data-id="element-245">
            <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-246">
              <div className="shrink-0 w-11 h-11 sm:w-12 sm:h-12 bg-pitahaya rounded-xl flex items-center justify-center shadow-lg shadow-pitahaya/30" data-id="element-247">
                <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-248" />
              </div>
              <div className="flex-1" data-id="element-249">
                <h2 className="font-serif text-lg sm:text-xl font-bold text-bunker leading-tight mb-0.5" data-id="element-250">
                  Mantén tu teléfono cerca
                </h2>
                <p className="font-sans text-bunker/70 text-xs sm:text-sm leading-snug" data-id="element-251">
                  Recibirás una llamada desde un número de México para coordinar
                  tu entrevista.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 sm:gap-3" data-id="element-252">
              <div className="flex items-center gap-2 bg-bunker/5 rounded-xl p-2.5 sm:p-3" data-id="element-253">
                <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-pitahaya shrink-0" data-id="element-254" />
                <div className="min-w-0" data-id="element-255">
                  <p className="font-sans font-bold text-xs text-bunker leading-tight" data-id="element-256">
                    Menos de 24 hrs
                  </p>
                  <p className="text-bunker/60 text-[10px] sm:text-xs leading-tight" data-id="element-257">
                    Respuesta
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-bunker/5 rounded-xl p-2.5 sm:p-3" data-id="element-258">
                <CalendarCheck className="w-4 h-4 sm:w-5 sm:h-5 text-pitahaya shrink-0" data-id="element-259" />
                <div className="min-w-0" data-id="element-260">
                  <p className="font-sans font-bold text-xs text-bunker leading-tight" data-id="element-261">
                    Sin costo
                  </p>
                  <p className="text-bunker/60 text-[10px] sm:text-xs leading-tight" data-id="element-262">
                    Entrevista privada
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Secondary — Guide download */}
          <div className="bg-white/5 border border-white/10 rounded-2xl sm:rounded-3xl p-3 sm:p-5 backdrop-blur-sm" data-id="element-263">
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4" data-id="element-264">
              <div className="shrink-0 w-10 h-10 bg-pitahaya/15 rounded-xl flex items-center justify-center" data-id="element-265">
                <Download className="w-5 h-5 text-pitahaya" data-id="element-266" />
              </div>
              <div className="text-center sm:text-left flex-1 min-w-0" data-id="element-267">
                <p className="font-sans text-[10px] uppercase tracking-widest text-pitahaya font-bold mb-0.5" data-id="element-268">
                  Mientras tanto
                </p>
                <h3 className="font-serif text-base sm:text-lg font-bold text-white leading-tight" data-id="element-269">
                  Descarga tu Guía de Blindaje
                </h3>
                <p className="font-sans text-xs text-earth/60 leading-snug mt-1" data-id="element-270">
                  Esta lectura te preparará para aprovechar al máximo tu
                  asesoría privada.
                </p>
              </div>
              <a href={GUIDE_URL} target="_blank" rel="noopener noreferrer" className="shrink-0 w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-pitahaya hover:bg-pitahaya-dark text-white font-sans font-bold uppercase tracking-wider px-5 py-2.5 text-xs rounded-full transition-all shadow-lg shadow-pitahaya/30 hover:scale-[1.02] active:scale-[0.98]" data-id="element-271">
                <Download className="w-4 h-4" data-id="element-272" />
                Descargar
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>;
}